"use client";
import { useState, useMemo } from "react";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
import { Layout } from "@/components/Layout/Layout";
import { ThoughtLeadershipCard } from "@/components/ThoughtLeadershipCard/ThoughtLeadershipCard";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import dayjs from "dayjs";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function NewsRelease({ pageData, news }) {
    const years = useMemo(() => {
        let yearsList = (news.docs || []).map((item) =>
            dayjs(item.publishDate).format("YYYY")
        );
        yearsList.sort(function (a, b) {
            return b - a;
        });
        yearsList = [...new Set(yearsList)];
        return yearsList;
    }, [news.docs]);

    const [active, setActive] = useState(() => {
        let yearsList = (news.docs || []).map((item) =>
            dayjs(item.publishDate).format("YYYY")
        );
        yearsList.sort(function (a, b) {
            return b - a;
        });
        yearsList = [...new Set(yearsList)];
        return yearsList[0];
    });

    const filteredNews = useMemo(() => {
        return (news.docs || []).filter(
            (item) => dayjs(item.publishDate).format("YYYY") === String(active)
        );
    }, [active, news.docs]);

    return (
        <Layout lightHeader={false}>
            <HeroHeader
                heading={HTMLReactParser(pageData.banner.title)}
                subHeading={HTMLReactParser(pageData.banner.text)}
            />
            <section>
                <div className="flex hp-container text-[14px] lg:text-[20px] text-text items-center justify-between">
                    <div className="custom_prev bg-white flex justify-center items-center rounded-[26.35px] pr-5 py-3 cursor-pointer">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="text-primary w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                            />
                        </svg>
                    </div>
                    {years.length > 0 && active ? (
                        <Swiper
                            slidesPerView={3}
                            centeredSlides={false}
                            loop={false}
                            modules={[Navigation]}
                            breakpoints={{
                                0: {
                                    slidesPerView: 3,
                                },
                                1024: {
                                    spaceBetween: 0,
                                    slidesPerView: 3,
                                },
                                1280: {
                                    spaceBetween: 0,
                                    slidesPerView: 3,
                                },
                            }}
                            navigation={{
                                nextEl: ".custom_next",
                                prevEl: ".custom_prev",
                            }}
                            className="w-full"
                        >
                            {years.map((year, key) => {
                                return (
                                    <SwiperSlide key={key}>
                                        <div
                                            className={`py-2 border-b-2 cursor-pointer flex justify-center ${active == year
                                                    ? "border-primary text-primary font-medium"
                                                    : "border-[#E9E9E9] text-text font-normal"
                                                }`}
                                            onClick={() => {
                                                setActive(year);
                                            }}
                                        >
                                            <h6>{year}</h6>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    ) : (
                        <></>
                    )}

                    <div className="custom_next bg-white flex justify-center items-center rounded-[26.35px] pl-5 py-3 cursor-pointer">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="text-primary w-6 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                            />
                        </svg>
                    </div>
                </div>
            </section>

            <section className="py-8">
                <div className="hp-container w-full grid grid-cols-1 items-center border-t border-[#D9D9D9]">
                    {filteredNews.length > 0 ? (
                        filteredNews.map((newsItem, key) => (
                            <ThoughtLeadershipCard
                                image={
                                    newsItem.image
                                        ? getImageSrc(newsItem.image.url)
                                        : null
                                }
                                title={newsItem.title}
                                date={dayjs(newsItem.publishDate).format(
                                    "D MMM YYYY"
                                )}
                                slug={newsItem.slug}
                                key={newsItem.slug || key}
                            />
                        ))
                    ) : (
                        <div className="flex justify-center py-6">
                            <h5>No articles for selected year</h5>
                        </div>
                    )}
                </div>
            </section>
        </Layout>
    );
}